export const RQ_GET_BRAND_DETAILING_APL = {
  url:'reports/brand/brand-sequence_report/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_PRODUCT_DETAILING_APL = {
  url:'reports/brand/product-sequence_report/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};
